import React from 'react';
import Gimp1 from "../assets/img/pageimages/Gimp1.jpeg";
import Gimp2 from "../assets/img/pageimages/Gimp2.jpeg";
import Gimp3 from "../assets/img/pageimages/Gimp3.jpeg";

function Gimp() {
  const images = [Gimp1, Gimp2, Gimp3];
 
  return (
    <>
      <style>
        {`
          /* Apply Poppins font family globally */
          body, h1, h2, h3, p, ul, li {
      fontFamily: "'Poppins', sans-serif",
            font-weight: 400;
          }
 
          .gimp-container {
            background: #f9fafb; /* Updated background color */
            color: #333;
            padding: 3rem 20px;
            margin: auto;
          }
 
          .gimp-header {
            margin-bottom: 40px;
          }
 
          .gimp-header h1 {
            color: #7620ff; /* Updated main heading color */
            margin-bottom: 16px;
            text-align:center;
          }
 
          .gimp-header p {
            max-width: 800px;
            margin: 0 auto;
            color: #555;
             line-height: 1.8;
          }
 
          .image-row {
            display: flex;
            flex-wrap: wrap;
            gap: 20px;
            justify-content: center;
            margin: 40px 0;
          }
 
          .image-row img {
            width: 100%;
            max-width: 300px;
            height: auto;
            border-radius: 8px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          }
 
          .section-title {
            margin: 40px 0 20px;
            color: #fdba00; /* Updated subheading color */
            text-align: center;
          }
 
          .section-text {
            color: #444;
            line-height: 1.6;
            max-width: 900px;
            margin: auto;
            text-align: justify;
          }
 
          .features-list {
            margin-top: 20px;
            padding-left: 20px;
          }
 
          .features-list li {
            margin-bottom: 10px;
          }
 
          .split-section {
            display: flex;
            flex-direction: column;
            gap: 30px;
            margin-top: 40px;
            max-width:80%;
            margin:30px auto;
          }
 
          @media (min-width: 768px) {
            .split-section {
              flex-direction: row;
            }
          }
 
          .split-box {
            flex: 1;
            background-color: #eef2ff;
            padding: 30px;
            border-radius: 10px;
            box-shadow: 0 2px 8px rgba(0,0,0,0.05);
          }
 
          .resource-link {
            display: inline-block;
            margin-top: 12px;
            background-color: #f0f8ff;
            color: #1e40af;
            text-decoration: none;
            padding: 10px 16px;
            border-radius: 6px;
            box-shadow: 0 1px 5px rgba(0,0,0,0.1);
            transition: background-color 0.3s;
          }
 
          .resource-link:hover {
            background-color: #dbeafe;
          }
        `}
      </style>
 
      <div className="gimp-container">
        <header className="gimp-header">
          <h1 style={{ marginTop: "4rem" }}>GIMP (GNU Image Manipulation Program)</h1>
          <p>
            GIMP is a powerful, open-source image editing software used for tasks such as photo retouching, image composition, and graphic design.
            Often compared to Adobe Photoshop, GIMP offers a wide array of tools and features, making it a popular choice for both professional designers and casual users.
          </p>
        </header>
 
        <div className="image-row">
          {images.map((src, index) => (
            <img key={index} src={src} alt={`GIMP ${index + 1}`} />
          ))}
        </div>
 
        <h2 className="section-title">What is GIMP?</h2>
        <p className="section-text">
          GIMP is a free and open-source raster graphics editor, similar to Adobe Photoshop. It's known for its versatility, allowing users to perform tasks ranging from basic photo editing to complex image manipulation and even original artwork creation. GIMP is available on multiple operating systems, including Windows, Linux, and macOS.
        </p>
 
        <h2 className="section-title">Key Features and Capabilities</h2>
        <ul className="section-text features-list">
          <li><strong>Image Manipulation:</strong> GIMP offers a wide range of tools for photo retouching, image composition, and restoration.</li>
          <li><strong>Drawing and Painting:</strong> It provides tools for free-hand drawing, painting with various brushes and styles, and creating original artwork.</li>
          <li><strong>File Format Support:</strong> Supports formats like JPEG, PNG, GIF, TIFF, and more.</li>
          <li><strong>Layer and Channel Support:</strong> Enables advanced editing using layers and channels.</li>
          <li><strong>Plugins and Scripting:</strong> Highly extensible with plugins and custom scripts.</li>
          <li><strong>Cross-Platform:</strong> Works on Windows, Linux, and macOS.</li>
        </ul>
 
        <h2 className="section-title">GIMP's History</h2>
        <p className="section-text">
          GIMP was initially developed by Peter Mattis and Spencer Kimball in 1995. It is now maintained by a community of volunteers as part of the GNU Project.
        </p>
 
        <p className="section-text" style={{ marginTop: '10px', textAlign: 'center', fontWeight: 'bold' }}>
          The newest version of GIMP is <span style={{ color: '#fdba00' }}>3.0</span>, released in March 2025.
        </p>
 
        <div className="split-section">
          <div className="split-box">
            <h3 style={{ color: '#fdba00' }}>Why Use GIMP?</h3>
            <p>
              GIMP is perfect for photo editing, graphic design, and illustration, offering a flexible and open-source solution to all your image manipulation needs.
              Its powerful features like customizable brushes, layers, and extensive plugin support make it a top choice for both casual users and professionals alike.
            </p>
          </div>
 
          <div className="split-box">
            <h3 style={{ color: '#fdba00' }}>Learn More About GIMP</h3>
            <a
              href="https://www.gimp.org/tutorials/"
              target="_blank"
              rel="noopener noreferrer"
              className="resource-link"
            >
              Getting Started with GIMP
            </a>
            <br />
            <a
              href="https://www.gimp.org/docs/"
              target="_blank"
              rel="noopener noreferrer"
              className="resource-link"
            >
              GIMP Documentation
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
 
export default Gimp;
 
 